import { render, staticRenderFns } from "./LeaderBoardTeam.vue?vue&type=template&id=81561afe&scoped=true"
import script from "./LeaderBoardTeam.vue?vue&type=script&lang=js"
export * from "./LeaderBoardTeam.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardTeam.vue?vue&type=style&index=0&id=81561afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81561afe",
  null
  
)

export default component.exports